import { render } from "./ListItems.vue?vue&type=template&id=b990281a&scoped=true"
import script from "./ListItems.vue?vue&type=script&lang=js"
export * from "./ListItems.vue?vue&type=script&lang=js"

import "./ListItems.vue?vue&type=style&index=0&id=b990281a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b990281a"]])

export default __exports__